import(/* webpackMode: "eager" */ "/codebuild/output/src1065407848/src/patient-app/src/components/loader/Loader.tsx");
